module.exports = __webpack_public_path__ + "static/img/2.b8e5be8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/about/news/hangye/20200402/2.png
// module id = g9lK
// module chunks = 1